module.exports = __webpack_public_path__ + "img/food-31.268d680a.jpg";